import React from 'react'
import './index.css'

const Logo = ({classNames}) => {
  return (
    <svg className={classNames} viewBox="0 0 1024 1026" xmlns="http://www.w3.org/2000/svg">
      <path fill="none" stroke="#000" strokeWidth="7" d="M571 1026L361 862l347-445 210 164zM1024 445l-70 91-211-164 71-91zM0 581l315 246 62-80L62 502zM453 0L276 227l315 246 177-227z"/>
      <path fill="#3084E8" stroke="#000" strokeWidth="7" d="M98 456l142-183 315 246-142 182z"/>
    </svg>)
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/index.js